function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v20H0z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.1 8l-.056.28-.211 1.029c-.338.13-.645.312-.922.53l-1.034-.346-.277-.086-.144.248-.712 1.19-.144.248.21.185.8.68a6.763 6.763 0 0 0 0 1.083l-.8.681-.21.185.144.248.712 1.19.144.25.277-.088 1.034-.346c.277.218.584.4.922.53l.211 1.028.056.281H15.1l.056-.28.21-1.029c.339-.13.645-.312.922-.53l1.034.346.278.087.144-.249.711-1.19.145-.248-.211-.185-.8-.68c.03-.179.03-.905 0-1.083l.8-.681.211-.185-.145-.248-.71-1.19-.145-.248-.278.086-1.034.346a3.548 3.548 0 0 0-.922-.53l-.21-1.028L15.1 8h-2.001z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.6 12.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M5 9.995h2M5 12.993h2M7 16.99H3a1 1 0 0 1-1-.998V3.999A1 1 0 0 1 3 3h10a1 1 0 0 1 1 1v1.834M5 6.997h5"
}))));

var SvgContentsSet = function SvgContentsSet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContentsSet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contents-set.3a697088.svg";
export { ForwardRef as ReactComponent };